import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset scroll on navigation.
 *
 * React Router keeps the previous scroll offset when the route changes, so a
 * footer link would land you at the bottom of the next page. This scrolls to
 * the top on every pathname change — unless the URL carries a hash, in which
 * case it scrolls that anchor into view (e.g. /privacy#security).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a frame so the target page has rendered the anchor.
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        window.scrollTo(0, 0);
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
